import type { EndPointConfig } from '../types/config';

// Build configuration from environment variables
// This will be populated at build time from .env
export const endPointConfig: EndPointConfig = {
  itemServiceOrigin: import.meta.env.VITE_TWINIT_ITEM_SERVICE_ORIGIN || 'https://sandbox-api.invicara.com',
  passportServiceOrigin: import.meta.env.VITE_TWINIT_PASSPORT_SERVICE_ORIGIN || 'https://sandbox-api.invicara.com',
  fileServiceOrigin: import.meta.env.VITE_TWINIT_FILE_SERVICE_ORIGIN || 'https://sandbox-api.invicara.com',
  datasourceServiceOrigin: import.meta.env.VITE_TWINIT_DATASOURCE_SERVICE_ORIGIN || 'https://sandbox-api.invicara.com',
  graphicsServiceOrigin: import.meta.env.VITE_TWINIT_GRAPHICS_SERVICE_ORIGIN || 'https://sandbox-api.invicara.com',
  notificationServiceOrigin: import.meta.env.VITE_TWINIT_NOTIFICATION_SERVICE_ORIGIN || 'https://sandbox-api.invicara.com',
  workflowServiceOrigin: import.meta.env.VITE_TWINIT_WORKFLOW_SERVICE_ORIGIN || 'https://sandbox-api.invicara.com',
  pluginBaseUrl: "",
  baseRoot: window.location.origin || import.meta.env.VITE_TWINIT_BASE_ROOT ||'http://localhost:8083',
  organizationId: import.meta.env.VITE_TWINIT_ORGANIZATION_ID || undefined,
  applicationId: import.meta.env.VITE_TWINIT_APPLICATION_ID || undefined,
  projectId: import.meta.env.VITE_TWINIT_PROJECT_ID || undefined,
  userGroupId: import.meta.env.VITE_TWINIT_USER_GROUP_ID || undefined,
};

// Check if window.endPointConfig exists (injected via script tag)
// This allows runtime configuration override
declare global {
  interface Window {
    endPointConfig?: Partial<EndPointConfig>;
  }
}

// Set endPointConfig on window immediately for ipa-core modules
if (typeof window !== 'undefined') {
  window.endPointConfig = endPointConfig;
}

export function getConfig(): EndPointConfig {
  // Merge with any runtime config from window
  if (typeof window !== 'undefined' && window.endPointConfig) {
    return {
      ...endPointConfig,
      ...window.endPointConfig,
    };
  }
  return endPointConfig;
}

export default getConfig;


